import $ from 'jquery';
import {getState} from '@shopify/theme-cart';

export default class Cart {
  constructor(element, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          count: '.cart__count',
        },
        classes: {
          updated: 'has-updated',
        },
        duration: 1000,
      },
      options,
    );

    this.$el = $(element);
    this.$count = $(this.options.selectors.count, this.$el);

    this.bind();
  }

  bind() {
    $(document).on('cart:updated', this.handleCartUpdated.bind(this));
  }

  handleCartUpdated() {
    getState()
      .then(this.updateCount.bind(this))
      .then(this.runDecorator.bind(this))
      .catch();
  }

  updateCount(result) {
    this.$count.text(result.item_count);
    return result;
  }

  runDecorator() {
    this.$el.addClass(this.options.classes.updated);

    window.setTimeout(() => {
      this.$el.removeClass(this.options.classes.updated);
    }, this.options.duration);
  }
}
